import MessagePreview from './message_preview';
import React          from 'react';
import Recipients     from './recipients';


export default function SendingStatusPage({ campaign }) {
  return (
    <>
      <SendingDescription {...{ campaign }}/>
      <Recipients {...{ campaign }}/>
      <MessagePreview {...{ campaign }}/>
    </>
  );
}


export function SendingDescription() {
  return (
    <div className="block description">
      <h2>Your campaign is now being sent.</h2>
      <p>Check back later for analytics on this campaign.</p>
    </div>
  );
}
